import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["breakpoints", "children", "layout", "id", "onRequestClose", "spacing", "width"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
import { getGlobalThemeValue } from 'utils/ui';
import Box from 'components/Box';
import Portal from 'components/Portal';
import CenterContent from 'components/CenterContent';
import useUniqueId from 'hooks/useUniqueId';
import usePrevious from 'hooks/usePrevious';
import { useModalManager } from './ModalManager';
import { fadeIn } from 'styles/animations';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ModalWrapper = styled.div.withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "sc-d7zgp2-0"
})(["position:absolute;top:0;left:0;width:100%;height:100%;height:100dvh;z-index:", ";overflow:auto;overscroll-behavior:contain;"], function (p) {
  return p.theme.globals.z.modals;
});
var ContentWrapper = styled.div.withConfig({
  displayName: "Modal__ContentWrapper",
  componentId: "sc-d7zgp2-1"
})(["position:relative;height:100%;"]);
var Overlay = styled.div.withConfig({
  displayName: "Modal__Overlay",
  componentId: "sc-d7zgp2-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(255,255,255,0.8);backdrop-filter:blur(0.5rem);&[data-should-fade-in='true']{animation:", " 0.3s ease forwards;}"], fadeIn);
function CenterOrFullscreen(_ref) {
  var breakpoints = _ref.breakpoints,
    children = _ref.children,
    layout = _ref.layout,
    spacing = _ref.spacing,
    width = _ref.width;
  if (layout === 'fullscreen') {
    return /*#__PURE__*/_jsx(Box, {
      height: "100%",
      overflow: "hidden",
      p: spacing,
      breakpoints: breakpoints,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CenterContent, {
    fillParent: true,
    p: spacing,
    contentWidth: getGlobalThemeValue('modalWidths', width),
    breakpoints: breakpoints,
    axis: layout === 'top-aligned' ? 'x' : 'both',
    children: children
  });
}
function Modal(_ref2) {
  var breakpoints = _ref2.breakpoints,
    children = _ref2.children,
    layout = _ref2.layout,
    id = _ref2.id,
    onRequestClose = _ref2.onRequestClose,
    spacing = _ref2.spacing,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 'default' : _ref2$width,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var uniqueId = useUniqueId(id);
  var _useModalManager = useModalManager({
      name: uniqueId,
      onRequestClose: onRequestClose
    }),
    modalRef = _useModalManager.modalRef,
    isAtTop = _useModalManager.isAtTop,
    modalCount = _useModalManager.modalCount;
  var previousModalCount = usePrevious(modalCount);
  var isFirstModalOpened = previousModalCount === 0 && modalCount === 1;
  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx(ModalWrapper, _objectSpread(_objectSpread({
      ref: modalRef,
      id: uniqueId
    }, otherProps), {}, {
      role: "dialog"
      // We don't need the aria-modal property here,
      // because we're "polyfilling" its effect (hiding
      // background content) using the 'aria-hidden' library,
      // which also gives us more control over it and allows
      // us to exclude certain elements from being hidden.
      // This solves issue https://github.com/5app/hub/issues/10949
      // aria-modal="true"
      ,
      children: /*#__PURE__*/_jsxs(CenterOrFullscreen, {
        layout: layout,
        spacing: spacing,
        width: width,
        breakpoints: breakpoints,
        children: [isAtTop && /*#__PURE__*/_jsx(Overlay, {
          "data-should-fade-in": isFirstModalOpened,
          onClick: onRequestClose
        }), /*#__PURE__*/_jsx(FocusLock, {
          group: "hub-overlay",
          as: ContentWrapper,
          children: children
        })]
      })
    }))
  });
}
export default Modal;